module.exports = __webpack_public_path__ + "img/72162d3.jpg";